import * as React from "react";
import Loading from "@ui-kit/splash-screen";

interface IProps {
  children: React.ReactNode;
}

const App = ({ children }: IProps) => {
  return <React.Suspense fallback={<Loading />}>{children}</React.Suspense>;
};

export default App;
